export const extensionMap: Record<string, { label: string }> = {
  capitaloneshopping: { label: "CapitalOneShopping" },
  honey: { label: "Honey" },
  Klarna: { label: "Klarna" },
  ibotta: { label: "Ibotta" },
  coupert: { label: "Coupert" },
  karmanow: { label: "Karma" },
  TopCashback: { label: "TopCashback" },
  cently: { label: "Cently" },
  CouponBirds: { label: "CouponBirds" },
  SimplyCodes: { label: "SimplyCodes" },
  DealMela: { label: "DealMela" },
  Checkmate: { label: "Checkmate" },
  "Codes.co.uk": { label: "Codes.co.uk" },
  ShopMail: { label: "ShopMail" },
  Moolah: { label: "Moolah" },
  Pie: { label: "Pie" },
  OffersLove: { label: "OffersLove" },
  rakuten: { label: "Rakuten" },
  FatCoupon: { label: "FatCoupon" },
  DealDrop: { label: "DealDrop" },
  retailmenot: { label: "RetailMeNot" },
  Slickdeals: { label: "Slickdeals" },
  BestPrice: { label: "BestPrice" },
  Ruby: { label: "Ruby" },
  oHcoupons: { label: "oHcoupons" },
  Mino: { label: "Mino" },
  CouponCabin: { label: "CouponCabin" },
  Mojo: { label: "Mojo" },
  DontPayFull: { label: "DontPayFull" },
  Shoppsie: { label: "Shoppsie" },
  CashbackEas: { label: "CashbackEase" },
  BeFrugal: { label: "BeFrugal" },
  Molly: { label: "Molly" },
  Rabatta: { label: "Rabatta" },
};
